module.exports = __webpack_public_path__ + "img/sidebar-battery-1.1991911d.svg";